export { default } from "./UniversalEmbedCardFooter.jsx";
